"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexDatesPicker = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FlexDatesPicker = function FlexDatesPicker(_ref) {
  var onChangeShift = _ref.onChangeShift,
      currentShift = _ref.currentShift,
      className = _ref.className;

  if (!_constants.FLEX_DATES.find(function (_ref2) {
    var shiftValue = _ref2.shiftValue;
    return shiftValue === currentShift;
  })) {
    throw new Error('В компонент FlexDatesPicker передана не зарегистрированная флексовая дата');
  }

  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className
  }, _constants.FLEX_DATES.map(function (_ref3) {
    var title = _ref3.title,
        shiftValue = _ref3.shiftValue;
    return /*#__PURE__*/_react["default"].createElement(Button, {
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        onChangeShift(shiftValue);
      },
      key: shiftValue,
      $isActive: shiftValue === currentShift
    }, title);
  }));
};

exports.FlexDatesPicker = FlexDatesPicker;

var Container = _styledComponents["default"].span.withConfig({
  displayName: "FlexDatesPicker__Container",
  componentId: "sc-132c5zo-0"
})(["display:flex;justify-content:space-around;& > button + button{margin-left:8px;}"]);

var Button = _styledComponents["default"].button.withConfig({
  displayName: "FlexDatesPicker__Button",
  componentId: "sc-132c5zo-1"
})(["color:#17181a;padding:8px;height:100%;border-radius:var(--border-radius);border:0;background-color:", ";color:", ";text-align:center;font-size:14px;font-weight:400;line-height:16px;cursor:pointer;"], function (_ref4) {
  var $isActive = _ref4.$isActive;
  return $isActive ? 'var(--grey1)' : 'var(--background)';
}, function (_ref5) {
  var $isActive = _ref5.$isActive;
  return $isActive ? 'var(--white)' : 'var(--black)';
});